import gql from 'graphql-tag';

const getCardCategoryCardGroupsQuery = gql`
  query getCardCategoryCardGroupsQuery($card_category_id: RecordID) {
    cardCategories(
      slice: { offset: 0, limit: 1 }
      card_category_id: $card_category_id
    ) {
      total
      records {
        id
        name
        is_active
        asset_image {
          id
          url
        }
        card_groups {
          total
          records {
            id
            name
          }
        }
      }
    }
  }
`;

export default getCardCategoryCardGroupsQuery;
